import React, { useState } from "react";
import { Button, Input, Label } from "@windmill/react-ui";
import PageTitle from "../components/Typography/PageTitle";
import { CheckIcon, UploadIcon } from "../icons";
import DocumentResults from "../components/Documents/ResultDocuments";
import OcrService from "../services/OcrService";
import DocumentService from "../services/DocumentService";
import UserService from "../services/UserService";
import Spinner from "../components/Spinner/Spinner";
import { useHistory } from "react-router-dom";
import { useAlert } from "react-alert";

const ocrService = new OcrService();
const documentService = new DocumentService();
const userService = new UserService();

const documentQueries = {
  cnpj: [
    { question: "Qual é o número do CNPJ?", alias: "cnpj" },
    { question: "Qual é a razão social da empresa?", alias: "razao_social" },
    { question: "Qual é a data de abertura?", alias: "data_abertura" },
    { question: "Qual é a situação cadastral?", alias: "situacao_cadastral" },
  ],
  cnh: [
    { question: "Qual é o número da CNH?", alias: "numero_cnh" },
    { question: "Qual é a categoria da CNH?", alias: "categoria_cnh" },
    { question: "Qual é a data de validade da CNH?", alias: "validade_cnh" },
  ],
  rg: [
    { question: "Qual é o número do RG?", alias: "numero_rg" },
    { question: "Qual é o órgão expedidor?", alias: "orgao_expedidor" },
    { question: "Qual é a data de expedição?", alias: "data_expedicao" },
  ],
  antt: [
    { question: "Qual é o número de RNTRC?", alias: "rntrc" },
    { question: "Qual é a validade do RNTRC?", alias: "validade_rntrc" },
    { question: "Qual é o CNPJ associado?", alias: "numero_cnpj" },
  ],
  crlv: [
    { question: "Qual é a placa do veículo?", alias: "placa_veiculo" },
    { question: "Qual é o número do RENAVAM?", alias: "renavam_veiculo" },
    { question: "Qual é o modelo do veículo?", alias: "modelo_veiculo" },
    { question: "Qual é o ano de fabricação?", alias: "ano_mod_fab" },
  ],
};

const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB

const Documents = () => {
  const history = useHistory();
  const [cnh, setCnh] = useState(null);
  const [carDocument, setCarDocument] = useState(null);
  const [resultCnh, setResultCnh] = useState(null);
  const [resultCarDocument, setResultCarDocument] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showDocuments, setShowDocuments] = useState(false);
  const user = userService.getUser();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const alert = useAlert();

  const [processedFiles, setProcessedFiles] = useState(0);
  const [totalFiles, setTotalFiles] = useState(0);


  const companyId = localStorage.getItem("companyId");

  const handleCnhChange = (e) => {
    const selectedFile = e.target.files[0];
    const validImageTypes = ["image/jpeg", "image/png", "image/jpg"];

    if (selectedFile && selectedFile.size > MAX_FILE_SIZE) {
      alert.error("O arquivo selecionado excede o tamanho máximo de 5 MB.");
      return;
    }

    // if (selectedFile && !validImageTypes.includes(selectedFile.type)) {
    //   alert.error(
    //     "Por favor, selecione um arquivo de imagem (JPEG, PNG, JPG)."
    //   );
    //   return;
    // }
    setCnh(selectedFile);
  };

  const handleCarDocumentChange = (e) => {
    const selectedFile = e.target.files[0];
    const validImageTypes = ["image/jpeg", "image/png", "image/jpg"];

    if (selectedFile && selectedFile.size > MAX_FILE_SIZE) {
      alert.error("O arquivo selecionado excede o tamanho máximo de 5 MB.");
      return;
    }

    // if (selectedFile && !validImageTypes.includes(selectedFile.type)) {
    //   alert.error(
    //     "Por favor, selecione um arquivo de imagem (JPEG, PNG, JPG)."
    //   );
    //   return;
    // }
    setCarDocument(selectedFile);
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result.split(",")[1]);
      reader.onerror = (error) => reject(error);
    });
  };

  const cnhInputRef = React.useRef(null);
  const carDocumentInputRef = React.useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      let cnhResult = null;
      let carDocumentResult = null;

      if (cnh) setTotalFiles((prevTotal) => prevTotal + 1);
      if (carDocument) setTotalFiles((prevTotal) => prevTotal + 1);

      if (cnh) {
        const cnhBase64 = await convertToBase64(cnh);

        const payload = {
          file_name: `${user.id}_cnh_${cnh.name}`,
          bucket_name: "keycore-uploads-docs",
          file_content: cnhBase64,
          file_type: "image",
          document_type: "cnh",
          queries: documentQueries["cnh"],
        };

        const uploadResponse = await ocrService.uploadDocument(payload);
        const documentId = uploadResponse.id;

        while (true) {
          const statusResponse = await ocrService.checkDocumentStatus(
            documentId
          );
          if (statusResponse.doc_status === "COMPLETED") {
            cnhResult = statusResponse;

            setProcessedFiles((prevProcessed) => prevProcessed + 1);
            break;
          } else if (statusResponse.doc_status === "ERROR") {
            throw new Error("Erro ao processar CNH");
          }
          await new Promise((resolve) => setTimeout(resolve, 2000));
        }

        setResultCnh(cnhResult);
      }

      if (carDocument) {
        const carDocumentBase64 = await convertToBase64(carDocument);
        const payload = {
          file_name: `${user.id}_carDocument_${carDocument.name}`,
          bucket_name: "keycore-uploads-docs",
          file_content: carDocumentBase64,
          file_type: "image",
          document_type: "crv",
          queries: documentQueries["crlv"],
        };

        const uploadResponse = await ocrService.uploadDocument(payload);
        const documentId = uploadResponse.id;

        while (true) {
          const statusResponse = await ocrService.checkDocumentStatus(
            documentId
          );
          if (statusResponse.doc_status === "COMPLETED") {
            carDocumentResult = statusResponse;
            setProcessedFiles((prevProcessed) => prevProcessed + 1);

            break;
          } else if (statusResponse.doc_status === "ERROR") {
            throw new Error("Erro ao processar Documento do Carro");
          }
          await new Promise((resolve) => setTimeout(resolve, 2000));
        }

        setResultCarDocument(carDocumentResult);
      }

      setShowDocuments(true);
    } catch (error) {
      console.error("Erro ao enviar arquivos", error);
      alert.error("Erro ao enviar arquivos: " + error.message);
    }
    setIsLoading(false);
  };

  const handleDocumentSubmission = async () => {
    try {
      const cnhData = {
        numeroCNH: resultCnh.data?.data?.numero_registro || resultCnh.data?.data?.cpf || "",
        cpfExtraido: resultCnh.data?.data?.cpf || "",
        url: resultCnh.url ? resultCnh.url : "null",
        motoristaId: user.id,
        empresaId: companyId,
      };

      const carDocumentData = {
        numeroCRLV: resultCarDocument.data?.data?.renavam || "",
        cpfExtraido: resultCarDocument.data?.data?.proprietario?.cpf_cnpj || resultCarDocument.data?.data?.cpf_cnpj || "",
        url: resultCarDocument.url ? resultCarDocument.url : "null",
        motoristaId: user.id,
        empresaId: companyId,
      };

      await documentService.submeterDocumento(cnhData);
      await documentService.submeterDocumento(carDocumentData);

      setIsSubmitted(true);
      alert.success("Documentos submetidos com sucesso!");
      //redirecionar para a página de my submissions
      setTimeout(() => {
        localStorage.removeItem("companyId");
        history.push("/app/subscriptions");
      }, 3000);
    } catch (error) {
      console.error("Erro ao submeter documentos", error);
      alert.error("Erro ao submeter documentos");
    }
  };

  return (
    <>
      <PageTitle>Documentos</PageTitle>
      <form onSubmit={handleSubmit} className="flex flex-col h-full">
        <div className="flex-grow grid grid-cols-1 md:grid-cols-2 gap-4">
          <div
            className="flex flex-col items-center p-4 border rounded-lg cursor-pointer"
            onClick={() => cnhInputRef.current.click()}
          >
            <Label
              onClick={(event) => event.stopPropagation()}
              htmlFor="cnh"
              className="flex flex-col items-center"
            >
              {cnh ? (
                <CheckIcon className="w-12 h-12 text-green-500" />
              ) : (
                <UploadIcon className="w-12 h-12 text-gray-500" />
              )}
              <span className="mt-2 cursor-pointer">
                CNH - Carteira Nacional de Habilitação
              </span>
              <span className="text-xs text-gray-500 cursor-pointer">
                (Frente e Verso no mesmo arquivo)
              </span>
              <Input
                type="file"
                ref={cnhInputRef}
                id="cnh"
                onChange={handleCnhChange}
                className="mt-1 hidden"
                required
              />
            </Label>
            {cnh && (
              <span className="mt-2 text-sm text-gray-600">{cnh.name}</span>
            )}
          </div>
          <div
            className="flex flex-col items-center p-4 border rounded-lg cursor-pointer"
            onClick={() => carDocumentInputRef.current.click()}
          >
            <Label
              htmlFor="carDocument"
              className="flex flex-col items-center cursor-pointer"
              onClick={(event) => event.stopPropagation()}
            >
              {carDocument ? (
                <CheckIcon className="w-12 h-12 text-green-500" />
              ) : (
                <UploadIcon className="w-12 h-12 text-gray-500" />
              )}
              <span className="mt-2 cursor-pointer">Documento do Carro</span>
              <span className="text-xs text-gray-500 cursor-pointer">
                (CRLV ou CRV)
              </span>
              <Input
                ref={carDocumentInputRef}
                type="file"
                id="carDocument"
                onChange={handleCarDocumentChange}
                className="mt-1 hidden"
                required
              />
            </Label>
            {carDocument && (
              <span className="mt-2 text-sm text-gray-600">
                {carDocument.name}
              </span>
            )}
          </div>
        </div>

        <Button
          type="submit"
          className="mt-4"
          disabled={!cnh || !carDocument || isLoading}
        >
          Enviar
        </Button>
      </form>

      <div className="flex-grow h-full flex justify-center items-center my-6">
        {isLoading && (
          <div className="text-center">
            <Spinner />
            <p>
              Aguarde, processando {processedFiles} de {totalFiles} arquivos...
            </p>
          </div>
        )}
      </div>
      {/* {showDocuments && !isLoading && (
        <>
          <DocumentResults
            resultCnh={resultCnh}
            resultCarDocument={resultCarDocument}
          />
          <Button
            className="mt-4"
            onClick={handleDocumentSubmission}
            disabled={isSubmitted}
          >
            Confirmar Submissão
          </Button>
        </>
      )} */}



    </>
  );
};

export default Documents;
